export const TeamsMatter={
    Technical:{
    
    Team:"Technical Team",
    Description:"The Technical team is the backbone for managing all technical functionalities of ACM. These volunteers are responsible for projects and handle them regularly. They include: Automatic ID Card Generator, Attendance Recording App, Automated Mail Sender, Online Receipts Generator and the Chapter Website."
},
EventsAndPR:{
    id:"Events",
    Team:"Events and PR Team",
    Description:"The Events and PR team is in charge of all event-related activites. They brainstorm various events, decide on which would be most suitable and helpful, handle PR and oversee the event for its successful implementation."
},
SocialMedia:{
    
    Team:"Social Media Team",
    Description:"The Social Media Team handles all the ACM accounts on various social media platforms. They post regularly on topics related to technology and try to develop curiosity in the world of computers. They combine knowledge and fun to give the best output to students everywhere."
},
Design:{
    id:"design",
    Team:"Design Team",
    Description:"The Design Team adds color to ACM. They design the posters, templates, banners and ACM ID cards. The team works constanlty to present the content in the most appealing way to its members, and increase engagement in the process. They add a creative touch to our team."
},
Coding:{
    id:"coding",
    Team:"Coding Team",
    Description:"The Coding Team imparts knowledge to the coding enthusiasts out there. Its motive is to spread knowledge about the role of coding in one's life. It conducts up to 4 sessions in a month and coding contests are held to better understand the willingness and interest of students. It enables students to test how far they are able to implement their logical thinking into the contests."
},
Creative:{
    id:"creative",
    Team:"Creative Team",  
    Description:"The Creative Team is where moments turn into memories! They capture the best shots, craft trending reels, and make sure every event shines on social media. Their work ensures that every achievement and memory is shared and celebrated."
}

}